import { emptySplitApi as api } from "../../../emptyApi";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    apiPortalV1ChatCopilotList: build.query<
      ApiPortalV1ChatCopilotListApiResponse,
      ApiPortalV1ChatCopilotListApiArg
    >({
      query: () => ({ url: `/api/portal/v1/chat/copilot/` }),
    }),
    apiPortalV1ChatCopilotCreate: build.mutation<
      ApiPortalV1ChatCopilotCreateApiResponse,
      ApiPortalV1ChatCopilotCreateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/portal/v1/chat/copilot/`,
        method: "POST",
        body: queryArg.chat,
      }),
    }),
    apiPortalV1ChatCopilotRetrieve: build.query<
      ApiPortalV1ChatCopilotRetrieveApiResponse,
      ApiPortalV1ChatCopilotRetrieveApiArg
    >({
      query: (queryArg) => ({
        url: `/api/portal/v1/chat/copilot/${queryArg.id}/`,
      }),
    }),
    apiPortalV1ChatCopilotUpdate: build.mutation<
      ApiPortalV1ChatCopilotUpdateApiResponse,
      ApiPortalV1ChatCopilotUpdateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/portal/v1/chat/copilot/${queryArg.id}/`,
        method: "PUT",
        body: queryArg.chat,
      }),
    }),
    apiPortalV1ChatCopilotPartialUpdate: build.mutation<
      ApiPortalV1ChatCopilotPartialUpdateApiResponse,
      ApiPortalV1ChatCopilotPartialUpdateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/portal/v1/chat/copilot/${queryArg.id}/`,
        method: "PATCH",
        body: queryArg.patchedChat,
      }),
    }),
    apiPortalV1ChatCopilotDestroy: build.mutation<
      ApiPortalV1ChatCopilotDestroyApiResponse,
      ApiPortalV1ChatCopilotDestroyApiArg
    >({
      query: (queryArg) => ({
        url: `/api/portal/v1/chat/copilot/${queryArg.id}/`,
        method: "DELETE",
      }),
    }),
    apiPortalV1ChatCopilotExportRetrieve: build.query<
      ApiPortalV1ChatCopilotExportRetrieveApiResponse,
      ApiPortalV1ChatCopilotExportRetrieveApiArg
    >({
      query: (queryArg) => ({
        url: `/api/portal/v1/chat/copilot/${queryArg.id}/export/`,
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as portalApi };
export type ApiPortalV1ChatCopilotListApiResponse =
  /** status 200  */ ChatRead[];
export type ApiPortalV1ChatCopilotListApiArg = void;
export type ApiPortalV1ChatCopilotCreateApiResponse =
  /** status 201  */ ChatRead;
export type ApiPortalV1ChatCopilotCreateApiArg = {
  chat: Chat;
};
export type ApiPortalV1ChatCopilotRetrieveApiResponse =
  /** status 200  */ ChatRead;
export type ApiPortalV1ChatCopilotRetrieveApiArg = {
  /** A unique integer value identifying this chat thread. */
  id: number;
};
export type ApiPortalV1ChatCopilotUpdateApiResponse =
  /** status 200  */ ChatRead;
export type ApiPortalV1ChatCopilotUpdateApiArg = {
  /** A unique integer value identifying this chat thread. */
  id: number;
  chat: Chat;
};
export type ApiPortalV1ChatCopilotPartialUpdateApiResponse =
  /** status 200  */ ChatRead;
export type ApiPortalV1ChatCopilotPartialUpdateApiArg = {
  /** A unique integer value identifying this chat thread. */
  id: number;
  patchedChat: PatchedChat;
};
export type ApiPortalV1ChatCopilotDestroyApiResponse = unknown;
export type ApiPortalV1ChatCopilotDestroyApiArg = {
  /** A unique integer value identifying this chat thread. */
  id: number;
};
export type ApiPortalV1ChatCopilotExportRetrieveApiResponse =
  /** status 200  */ ChatRead;
export type ApiPortalV1ChatCopilotExportRetrieveApiArg = {
  /** A unique integer value identifying this chat thread. */
  id: number;
};
export type Chat = {
  name: string;
};
export type ChatRead = {
  id: number;
  name: string;
  created_at: string;
  updated_at: string;
};
export type PatchedChat = {
  name?: string;
};
export type PatchedChatRead = {
  id?: number;
  name?: string;
  created_at?: string;
  updated_at?: string;
};
export const {
  useApiPortalV1ChatCopilotListQuery,
  useApiPortalV1ChatCopilotCreateMutation,
  useApiPortalV1ChatCopilotRetrieveQuery,
  useApiPortalV1ChatCopilotUpdateMutation,
  useApiPortalV1ChatCopilotPartialUpdateMutation,
  useApiPortalV1ChatCopilotDestroyMutation,
  useApiPortalV1ChatCopilotExportRetrieveQuery,
} = injectedRtkApi;
